import React, { useState } from 'react';
import { Breadcrumb, Button, Dropdown, DropdownButton, Form, InputGroup, Spinner } from 'react-bootstrap';
import { useSelector } from 'react-redux';
import iconDownload from '../../assets/SidebarIcons/icon-download.svg';
import searchIcon from '../../assets/SidebarIcons/icon-search.svg';
import { downloadFile } from '../../helpers/apiHandler';
import CustomAlert from '../CustomAlert';
import '../Admin/_smsCampaign.scss';

const AdminCampaignHeading = ({ handleSearch, search, setSearch, selectedRange, setSelectedRange, setDateRange, data }) => {
  const { access_token } = useSelector((state) => state.auth.user);
  const [loadingDownload, setLoadingDownload] = useState(false);

  const [alertState, setAlertState] = useState({
    show: false,
    variant: 'danger',
    message: '',
  });

  const handleDownload = () => {
    setLoadingDownload(true);
    downloadFile(
      {
        url: '/admin/sms-campaign-export',
        data: {
          data: data,
        },
        access_token: access_token,
        fileName: 'campaign-export.csv',
      },
      (res) => {
        if (!res.error) {
          setAlertState({
            message: 'Your campaign(s) have been successfully exported to excel.',
            show: true,
            variant: 'success',
          });
        } else {
          setAlertState({
            message:
              'We apologize, but it seems there was an issue exporting your campaign(s) to Excel.',
            show: true,
            variant: 'danger',
          });
        }
        setLoadingDownload(false);
      }
    );
  };

  const handleRangeChange = (range) => {
    let selectedText;
    switch (range) {
      case '1_day':
        selectedText = '1 Day';
        break;
      case '7_day':
        selectedText = '7 Days';
        break;
      case '1_month':
        selectedText = '1 Month';
        break;
      case '3_month':
        selectedText = '3 Months';
        break;
      case '6_month':
        selectedText = '6 Months';
        break;
      case '12_month':
        selectedText = '12 Months';
        break;
      default:
        selectedText = '7 Days';
    }
    setSelectedRange(selectedText);
    setDateRange(range);
  };

  return (
    <div>
      <CustomAlert
        message={alertState.message}
        show={alertState.show}
        variant={alertState.variant}
        closeAlert={() => setAlertState({ show: false, variant: 'danger', message: '' })}
      />
      <div className="page-heading admin-heading">
        <div className="container-left" style={{ marginBottom: "32px"}}>
          <div className="page-title">SMS Campaign Report</div>
        </div>
        <div className='w-100'>
        <Form onSubmit={handleSearch} className="search-form" style={{maxWidth: "100%"}}>
          <div className="left-section">
            <InputGroup className="datatable-search">
              <InputGroup.Text>
                <img alt="..." src={searchIcon} />
              </InputGroup.Text>
              <Form.Control
                placeholder="Search..."
                name="search"
                value={search}
                onChange={(e) => setSearch(e.target.value)}
                type="text"
                className="search-form"
              />
            </InputGroup>
          </div>
          <div className="right-section">
            <Dropdown>
              <Dropdown.Toggle variant="ghost" style={{ minWidth: 160 }}>
                {selectedRange}
              </Dropdown.Toggle>
              <Dropdown.Menu>
                <Dropdown.Item onClick={() => handleRangeChange('1_day')}>1 Day</Dropdown.Item>
                <Dropdown.Item onClick={() => handleRangeChange('7_day')}>7 Days</Dropdown.Item>
                <Dropdown.Item onClick={() => handleRangeChange('1_month')}>1 Month</Dropdown.Item>
                <Dropdown.Item onClick={() => handleRangeChange('3_month')}>3 Months</Dropdown.Item>
                <Dropdown.Item onClick={() => handleRangeChange('6_month')}>6 Months</Dropdown.Item>
                <Dropdown.Item onClick={() => handleRangeChange('12_month')}>12 Months</Dropdown.Item>
              </Dropdown.Menu>
            </Dropdown>
            <Button
              variant="primary"
              disabled={loadingDownload}
              style={{ minWidth: 160 }}
              onClick={handleDownload}
            >
              {loadingDownload ? (
                <Spinner animation="border" size="sm" className="mr-2" />
              ) : (
                <img src={iconDownload} alt="..." style={{ marginRight: 8 }} />
              )}
              Export to Excel
            </Button>
          </div>
        </Form>
        </div>
      </div>
    </div>
  );
};

export default AdminCampaignHeading;
